import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { MapApp } from '../views';
import mapConfig from './MapConfig';
import i18n from '../i18n';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

createApp(MapApp, mapConfig)
  .use(pinia)
  .use(i18n)
  .mount('#calmac-map');
